/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TranslatorProviderType } from './TranslatorProviderType';
import {
    TranslatorProviderTypeFromJSON,
    TranslatorProviderTypeFromJSONTyped,
    TranslatorProviderTypeToJSON,
    TranslatorProviderTypeToJSONTyped,
} from './TranslatorProviderType';

/**
 * 
 * @export
 * @interface TextTranslationRequest
 */
export interface TextTranslationRequest {
    /**
     * 
     * @type {string}
     * @memberof TextTranslationRequest
     */
    text: string;
    /**
     * 
     * @type {TranslatorProviderType}
     * @memberof TextTranslationRequest
     */
    translatorProviderType: TranslatorProviderType;
}



/**
 * Check if a given object implements the TextTranslationRequest interface.
 */
export function instanceOfTextTranslationRequest(value: object): value is TextTranslationRequest {
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('translatorProviderType' in value) || value['translatorProviderType'] === undefined) return false;
    return true;
}

export function TextTranslationRequestFromJSON(json: any): TextTranslationRequest {
    return TextTranslationRequestFromJSONTyped(json, false);
}

export function TextTranslationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TextTranslationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'],
        'translatorProviderType': TranslatorProviderTypeFromJSON(json['translatorProviderType']),
    };
}

export function TextTranslationRequestToJSON(json: any): TextTranslationRequest {
    return TextTranslationRequestToJSONTyped(json, false);
}

export function TextTranslationRequestToJSONTyped(value?: TextTranslationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
        'translatorProviderType': TranslatorProviderTypeToJSON(value['translatorProviderType']),
    };
}

